import {} from "react";

export enum TrackingCampaign {
  ProUpgrade = "ProUpgrade",
}

export enum TrackingAction {
  Click = "Click",
}

export enum TrackingMedium {
  Cta = "Cta",
  PlanBadge = "PlanBadge",
}
